import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { fetchMe, type KidBundle, type ParentBundle } from "../api/me.js";

type Bundle = KidBundle | ParentBundle;

interface Ctx {
  bundle: Bundle | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

const UserContext = createContext<Ctx>({
  bundle: null,
  loading: true,
  refresh: async () => {},
});

export function UserProvider({ children }: { children: ReactNode }) {
  const [bundle, setBundle] = useState<Bundle | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const b = await fetchMe();
      setBundle(b);
    } catch {
      setBundle(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void refresh();
  }, []);

  return (
    <UserContext.Provider value={{ bundle, loading, refresh }}>{children}</UserContext.Provider>
  );
}

export function useUser(): Ctx {
  return useContext(UserContext);
}
